// --- React
import { useEffect, useRef } from "react";
// --- Utils
import { getJobViewDealSearchProgress } from "tap/utils/jobViewDealProgress.js";

/**
 * Deal-search progress for Job View with monotonic progressCount while pending.
 * @param {Object|null|undefined} selectedJob
 * @param {Array} [jobTasks]
 * @param {Array} [pendingStatuses]
 * @returns {ReturnType<typeof getJobViewDealSearchProgress>}
 */
export function useJobViewDealSearchDisplay(
  selectedJob,
  jobTasks = [],
  pendingStatuses = [],
) {
  const monotonicRef = useRef(0);
  const progress = getJobViewDealSearchProgress(selectedJob, jobTasks);
  const isPending = pendingStatuses.includes(selectedJob?.jobStatus);

  useEffect(() => {
    monotonicRef.current = 0;
  }, [selectedJob?.id]);

  if (!progress.visible) {
    return progress;
  }

  if (progress.isComplete || !isPending) {
    monotonicRef.current = progress.progressCount;
    return progress;
  }

  const displayCount = Math.max(
    monotonicRef.current,
    progress.progressCount,
  );
  monotonicRef.current = displayCount;

  if (displayCount === progress.progressCount) {
    return progress;
  }

  const percent = Math.min(
    100,
    Math.round((displayCount / progress.targetCount) * 100),
  );

  return {
    ...progress,
    progressCount: displayCount,
    percent,
    isComplete: percent >= 100,
  };
}
